import { useState, useEffect } from "react";
import parse from "html-react-parser";

//Components
import Card from "./Components/Card.js";
import Header from "./Components/Header.js";
import Footer from "./Components/Footer.js";

export default function App() {
  const [woods, setWood] = useState([]); //state varible, varible updater function, default value

  useEffect(() => {
    fetch("https://firefood.uk/wp-json/wp/v2/wood?acf_format=standard") //get the json data
      .then((res) => res.json()) //convert the json to a js object
      .then((data) => setWood(data)); //update the state with the js
    //.then((woods) => console.log(woods)); //update the state with the js
  }, []);

  const [search, setSearch] = useState("");

  return (
    <>
      <header>
        <div className="container">
          <div className="row d-flex justify-content-center pt-5 pb-5">
            <div className="col-11 col-sm-8">
              <Header title="Wood Smoke" />
              <form>
                <input
                  onChange={(e) => setSearch(e.target.value)}
                  type="text"
                  className="form-control"
                  placeholder="Search Woods"
                />
              </form>
            </div>
          </div>
        </div>
      </header>
      <div className="container mt-5">
        <div className="row d-flex justify-content-center">
          {woods
            .filter((wood) => {
              return search.toLowerCase() === ""
                ? wood
                : wood.title.rendered.toLowerCase().includes(search);
            })
            .map((wood) => (
              <div className="col-11 col-sm-8">
                <Card
                  key={wood.id}
                  title={wood.title.rendered}
                  content={parse(wood.content.rendered)}
                  imgUrl={wood.acf.image.url}
                />
              </div>
            ))}
        </div>
      </div>
      <div className="container">
        <div className="row d-flex justify-content-center pb-5">
          <div className="col-11 col-sm-8">
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}
